export default __webpack_public_path__ + "static/media/110.86e2669d.jpeg";